import React from 'react';

import { Row, Column, Teaser } from '@ard-online/component-styleguide';

import { TeaserCont } from '../styles';

const logos = [
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/caiway_logo.png'),
      "alt": "Logo Caiway"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/copydan_logo.svg'),
      "alt": "Logo Copydan"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/delta_logo.svg'),
      "alt": "Logo Delta"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/irf_logo.svg'),
      "alt": "Logo IRF"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/lassen-ricard_logo.svg'),
      "alt": "Logo Lassen Ricard"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/meo_logo.svg'),
      "alt": "Logo MEO"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/orange_logo.svg'),
      "alt": "Logo Orange"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/sfr_logo.svg'),
      "alt": "Logo SFR"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/t-mobile_logo.png'),
      "alt": "Logo T-Mobile"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/telenet_logo.svg'),
      "alt": "Logo Telenet"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/vgr_logo.svg'),
      "alt": "Logo VGR"
    }
  },
  {
    "type": "media",
    "href": null,
    "image": {
      "src": require('../images/logos/ziggo_logo.svg'),
      "alt": "Logo Ziggo"
    }
  }
]

const teaser1 = {
	"type": "collection",
	"title": "One touch point for the ARD network",
  "image":{
    "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
  }
};
const teaser2 = {
	"type": "collection",
	"title": "Channel bouquet consulting",
  "image":{
    "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
  }
};
const teaser3 = {
	"type": "collection",
	"title": "Marketing support",
  "image":{
    "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
  }
};

export default function ServicesReferencesSection() {
  return (
    <section id="services-references">
      <Row>
        <Column>
          <h2>Service &amp; Referenzen</h2>
          <h3>ARD Channels International - Was wir für Sie tun können</h3>
        </Column>
      </Row>
      <Row className="service-container" >
        <Column className="service" all={12} xs={12} s={6} m={4}>
          { /* <TeaserCont>
            <Teaser {...teaser1} textPosition="onImage" textAlignment="center" />
          </TeaserCont> */ }
          <h3>Ein Ansprechpartner für die ARD</h3>
          <p>Wir sind der zentrale Ansprechpartner der ARD-Rundfunkanstalten für die Programmweiterverbreitung in Europa. Grundlage unserer Tätigkeit sind die EU-Satelliten- und Kabelrichtlinien, die die Lizenzierung von Urheber- und verwandten Schutzrechten im europäischen Binnenmarkt, u.a. im Bereich der (Kabel-)Weiterverbreitung, regeln.</p>
        </Column>
        <Column className="service" all={12} xs={12} s={6} m={4}>
          { /* <TeaserCont>
            <Teaser {...teaser2} textPosition="onImage" textAlignment="center" />
          </TeaserCont> */ }
          <h3>Beratung bei der Senderauswahl</h3>
          <p>Mit unserer langjährigen Erfahrung im Bereich der Programmweiterverbreitung in Europa unterstützen wir Sie gern dabei, eine auf Ihren Markt individuell zugeschnittene Auswahl aus dem vielfältigen ARD-Senderangebot zu treffen.</p>
        </Column>
        <Column className="service" all={12} xs={12} s={6} m={4}>
          { /* <TeaserCont>
            <Teaser {...teaser3} textPosition="onImage" textAlignment="center" />
          </TeaserCont> */ }
          <h3>Unterstützung im Marketing</h3>
          <p>Wir unterstützen Ihre Marketingaktivitäten durch die Bereitstellung von relevanten Informationen und Materialien rund um unsere Sender, sodass Sie Ihrer Zielgruppe einen umfassenden Überblick über unser erstklassiges Programmangebot geben können.</p>
        </Column>
      </Row>
      <Row className="references">
        <Column>
          <h3>Referenzen</h3>
        </Column>
        { logos.map((logo, index) => 
          <Column key={index} all={4} xs={4} s={3} m={3}>
            <TeaserCont>
              <Teaser {...logo}/>
            </TeaserCont>
          </Column>
        )}
      </Row>
    </section>
  );
}